/* @flow */

import type { ZalgoPromise } from './promise';

let activeCount = 0;
let flushPromise;

function flushActive() {
    if (!activeCount && flushPromise) {
        const promise = flushPromise;
        flushPromise = null;
        promise.resolve();
    }
}

export function startActive() {
    activeCount += 1;
}

export function endActive() {
    activeCount -= 1;
    flushActive();
}

export function awaitActive(Zalgo : Class<ZalgoPromise<*>>) : ZalgoPromise<void> { // eslint-disable-line no-undef
    let promise = flushPromise = flushPromise || new Zalgo();
    flushActive();
    return promise;
}



// WEBPACK FOOTER //
// ./node_modules/zalgo-promise/src/flush.js